import config from 'config'
import env from 'env'

export const DOMAIN = env === 'local' ? config.domain : location.origin